import React, { Component, useState, useEffect } from "react";
import { Table, Modal , DatePicker } from "antd";
import moment from "moment";
import Cookies from "js-cookie";
import Api from "../../../../../../services/ServiceApi";
const { RangePicker } = DatePicker;
const JobTypeModal = ({ isVisible, setIsVisible, dataSource, title }) => {

  const [opernModal, setopernModal] = useState(false);
  const [dataModal, setdataModal] = useState([]);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const columns = [
    // {
    //   title: "Bus locking ID",
    //   dataIndex: "bus_locking_id",
    //   key: "bus_locking_id",
    // },
    // {
    //   title: "Locking Code",
    //   dataIndex: "locking_code",
    //   key: "locking_code",
    // },
    // {
    //   title: "Job Type",
    //   dataIndex: "job_type",
    //   key: "job_type",
    // },
    {
      title: "Job ID",
      dataIndex: "job_id",
      key: "job_id",
    },
    {
      title: "Job No",
      dataIndex: "job_no",
      key: "job_no",
    },
    {
      title: "Job Status",
      dataIndex: "job_status",
      key: "job_status",
    },
    {
      title: "Plan Start Date",
      dataIndex: "",
      key: "",
      render: (item) => (
        <span>{moment(item.plan_start_date).format("DD/MM/YYYY HH:mm")}</span>
      )
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      align: "center",
      render: (item) => (
        <img
          src={Api.absoluteUrl("/icon/icon_edit.svg")}
          className="mr-2"
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            setdataModal(item);
            setopernModal(true);
          }}
        />
      )
    },
    // {
    //   title: "Start Date",
    //   dataIndex: "create_date",
    //   key: "create_date",
    //   render: (date) => <span>{date.slice(0,10)}</span>
    // },
  ];
  const dateFormat = 'DD/MM/YYYY';



  const saveEdit   = async () => {
    const BusUpdateJobPlan = await  Api.post("BusUpdateJobPlan", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      "job_id" : dataModal.job_id,
      "plan_start_date" : StartDate,
      "plan_end_date" : EndDate ,
      create_by: Cookies.get("userId"),
    });
    if(BusUpdateJobPlan.data.result.code === "p"){
      alert( BusUpdateJobPlan.data.result.description);
      setopernModal(false);
    }
    else{
      alert(" Fell Update ");
    }
  }
  return (
    <React.Fragment>
      <Modal
        title={title}
        visible={isVisible}
        onOk={() => setIsVisible(false)}
        onCancel={() => setIsVisible(false)}
        width={800}
      >
        <Table dataSource={dataSource} columns={columns} />
      </Modal>
      <Modal
        title={"Job No. " + dataModal.job_no}
        visible={opernModal}
        onOk={() => saveEdit()}
        onCancel={() => setopernModal(false)}
        width={800}
        style={{marginTop: "8rem"}}
      >
        <div className="row">
          <div className="col-6">
          <span class="font-thai-r font18 c-blue font-bold">Plan Start Date - Plan End Date </span>
          </div>
          <div className="col-6">
          <RangePicker
                onChange={(val) => {
                  let start = moment(val[0]).format('YYYY-MM-DD');
                  let end = moment(val[1]).format('YYYY-MM-DD');
                  setStartDate(start);
                  setEndDate(end);
                }}
                format={dateFormat}
                defaultValue={
                [
                  moment(moment(dataModal.plan_start_date).format('DD/MM/YYYY'), dateFormat), 
                  moment(moment(dataModal.plan_start_date).format('DD/MM/YYYY'), dateFormat)
                ]}
                allowClear
                style={{
                  marginLeft: "10px",
                  color: "#000F9F",
                  marginRight: "20px",
                }}
              />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default JobTypeModal;
